import { useTranslation } from 'react-i18next';
import BllinkUtils from '../../common/utils/utils';
import { constants } from '../../common/constants/constants';
import { calcMonthsTextForSelectBox, shortenText } from '../../common/shared/statelessMethods';

const TimeUtils = BllinkUtils.BllinkTime;

const ColectionPdfRow = ({ record, bllinkCharges }) => {
    const { t } = useTranslation();

    const depositDate = TimeUtils.parseDate(record.depositDate);
    const chargeDate = TimeUtils.parseDate(record?.chargeDate);
    const statusKey = constants.PaymentPlanDetailsStatus[record.paymentState]; 
    const status = statusKey ? t(`statuses.${statusKey}`) : '';

    const paymentComment = () => {
        let comment = '';
        if (record.months && record.months.length > 0) comment = shortenText(calcMonthsTextForSelectBox(record.months));
        else if (record.oneTime) comment = shortenText(record.oneTime.description);
        return comment.shortComment;
    };

    return (
        <>
            {bllinkCharges && (
                <div className='pdf-row'>
                    <div className='yearly-apt'>{chargeDate}</div>
                    <div className='yearly-apt'>{depositDate}</div>
                    <div className='yearly-apt'>{record.amount}</div>
                    <div className='yearly-apt'>{record.apartmentNum}</div>
                    <div className='yearly-apt'>{record.tenantName}</div>
                    <div className='yearly-apt'>{paymentComment()}</div>
                    <div className='yearly-apt'>{t(`buildings.${record.paymentType}`)}</div>
                    <div className='yearly-apt'>{status}</div>
                </div>
            )}
            {!bllinkCharges && (
                <div className='pdf-row'>
                    <div className='expenses'>{depositDate}</div>
                    <div className='expenses'>{record.amount}</div>
                    <div className='expenses'>{record.apartmentNum}</div>
                    <div className='expenses'>{record.tenantName}</div>
                    <div className='expenses'>{paymentComment()}</div>
                    <div className='expenses'>{t(`buildings.${record.paymentType}`)}</div>
                    <div className='expenses'>{status}</div>
                </div>
            )}     
        </>
    )
}

export default ColectionPdfRow;